import type { UnknownEvent } from '@faststore/sdk'
import { sendAnalyticsEvent } from '@faststore/sdk'
import Link from 'src/components/ui/Link'

import type { HeroCarouselItemButtonProps } from '../hero-carousel'
import { getCustomStyles } from '../utils'

interface ButtonProps {
  button?: HeroCarouselItemButtonProps
}

const Button = ({ button }: ButtonProps) => {
  const customStylesButton = getCustomStyles(button?.styles)

  const handleClick = () => {
    sendAnalyticsEvent<UnknownEvent>({
      name: 'select_promotion',
      params: {
        promo: button?.to,
      },
    })
  }

  if (!button) {
    return <></>
  }

  return (
    <>
      <div className="font-normal max-w-full pb-1">
        <Link as="a" href={button?.to} onClick={handleClick}>
          <button
            className="md:w-[350px] border-transparent rounded-[99px] cursor-pointer max-w-full py-2 px-5"
            style={customStylesButton}
          >
            {button?.label}
          </button>
        </Link>
      </div>
    </>
  )
}

export default Button
